/**
 * Valid APIV3 position id has the following format: {serverId}_{boxId}_{timestamp80}
 *
 * Count the number of occurences of one character in the string
 * ("41_123_12312312312".match(new RegExp("_", "g")) || []).length
 * @param {*} positionId
 * @returns
 */
export function isValidPositionId(positionId) {
  return (
    positionId &&
    (positionId || '').toString().includes('_') &&
    !(positionId || '').toString().includes('id_') &&
    ((positionId || '').toString().match(new RegExp('_', 'g')) || []).length ===
      2
  )
}

/**
 * Filters out invalid positions from an array of objects.
 *
 * @param {Object} item position item
 * @returns {Boolean} True/False
 */
export function filterValidPositionHandler(item) {
  let lat = item.lat || item.latitude
  let lon = item.lon || item.lng || item.longitude
  // Check if the item has both 'lat' or 'latitude' and 'lon', 'lng', or 'longitude' properties
  if (!lat || !lon) {
    return false // Filter out if either property is missing
  }
  // Check if 'lat' or 'lon' are invalid (0, null, or empty string)
  if (!lat || !lon || lat === 0 || lon === 0) {
    return false // Filter out if either value is invalid
  }
  return true // Keep the item if it passes all checks
}

export function splitInvalidAndValidPositions(arr) {
  let invalid = [],
    valid = []
  arr.forEach((item) => {
    if (filterValidPositionHandler(item)) {
      item.lng = item.lng || item.lon
      valid.push(Object.freeze(item)) //Disable reactivity at item level
    } else {
      invalid.push(item)
    }
  })
  return { invalid, valid }
}
